import { IProductOwner } from "./product-owner";

export interface IProductOwners {
    [index: string]: IProductOwner,
}